<template>
  <v-row justify="center" v-show="gameOverDialog" class="dialog-container">
    <v-dialog v-model="gameOverDialog" persistent max-width="900">
      <v-card tile flat>
        <v-card-title class="headline">Mérkőzés vége</v-card-title>
        <v-card-text>
          <p v-show="draftCount" type="warning">
            A jegyzőkönyvben <strong>{{ draftCount }}</strong> vázlat esemény van, ezeket vagy törölje, vagy
            véglegesítse!<br/>
          </p>
          <p v-show="rejectedCount" type="warning">
            A jegyzőkönyvben <strong>{{ rejectedCount }}</strong> elutasított esemény van, ezeket vagy törölje, vagy
            módosítsa az indoklás szerint!<br/>
          </p>
          <p v-show="draftCount || rejectedCount">
            Ezek után a bal felső menüben található <code>Beküldés</code> gomb segítségével küldheti be a
            véglegesített jegyzőkönyvet!
          </p>
          <p v-show="!draftCount && !rejectedCount">Szeretné most beküldeni az állapotot?</p>
          <p v-show="!draftCount && !rejectedCount">Amennyiben nem, a bal felső hamburger menüben található <code>Beküldés</code>
            gomb segítségével bármikor beküldheti</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn depressed tile v-show="!draftCount && !rejectedCount"
                 @click="bekuldes">Beküldés
          </v-btn>
          <v-btn depressed tile @click="megsem">Mégsem</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import {mapMutations, mapState} from "vuex";

export default {
  computed:{
    ...mapState('game', ['draftCount', 'rejectedCount']),
    ...mapState('ui', ['gameOverDialog', 'GameFinishDialog'])
  },
  methods: {
    ...mapMutations('ui', ['SET_GAMEOVERDIALOG', 'SET_GAMEFINISHDIALOG']),
    bekuldes() {
      this.SET_GAMEOVERDIALOG(false);
      this.SET_GAMEFINISHDIALOG(true);
    },
    megsem() {
      this.SET_GAMEOVERDIALOG(false);
    }
  }
}
</script>

<style scoped>

</style>
